import { SectionTitle } from '@atoms/SectionTitle';

const STEPS = [
  {
    step: '01',
    title: 'Hesap Oluşturun',
    description: 'Restoran veya toptancı olarak kayıt olun ve profilinizi tamamlayın.',
  },
  {
    step: '02',
    title: 'Toptancı Seçin',
    description: 'Bölgenizdeki güvenilir toptancıları keşfedin, ürün kataloglarını inceleyin.',
  },
  {
    step: '03',
    title: 'Sipariş Verin',
    description: 'Sepete ekleyin, siparişinizi oluşturun ve tedarik sürecinizi takip edin.',
  },
];

export function HowItWorksSection() {
  return (
    <section className="bg-white py-16 md:py-20">
      <div className="section-container">
        <SectionTitle
          title="Nasıl "
          accent="Çalışır?"
          subtitle="Üç adımda profesyonel toptan tedarik sürecinizi başlatın."
        />
        <div className="grid gap-8 md:grid-cols-3">
          {STEPS.map((item, idx) => (
            <div key={item.step} className="relative">
              {idx < STEPS.length - 1 && (
                <div className="absolute left-8 top-12 hidden h-px w-[calc(100%-2rem)] bg-slate-200 md:block" />
              )}
              <div className="flex gap-5">
                <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-slate-900 text-sm font-bold text-white">
                  {item.step}
                </span>
                <div>
                  <h3 className="text-lg font-semibold text-slate-900">{item.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-slate-600">{item.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
